import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, Observable } from 'rxjs';
import { catchError, map, withLatestFrom, switchMap } from 'rxjs/operators';
import { MarketDrawerRootReducerState } from '../reducer';
import { TreasuriesService } from '../../services/treasuries.service';
import { USTreasuries } from '../../models/us-treasury';
import {
  USTREASURIES_LOAD_REQUESTED,
  USTreasuriesLoadSuccessAction,
  USTreasuriesLoadErrorAction
} from './actions';

@Injectable()
export class USTreasuriesEffects {
  @Effect()
  public loadUSTreasuries$: Observable<
    USTreasuriesLoadSuccessAction | USTreasuriesLoadErrorAction
  > = this.actions.pipe(
    ofType(USTREASURIES_LOAD_REQUESTED),
    withLatestFrom(this.store),
    switchMap(
      ([action, state]): Observable<
        USTreasuriesLoadSuccessAction | USTreasuriesLoadErrorAction
      > =>
        this.treasuriesService.fetchData(state.marketDrawer.dealDate).pipe(
          map(
            (usTreasuries: USTreasuries) =>
              new USTreasuriesLoadSuccessAction(usTreasuries)
          ),
          catchError((error: Error) =>
            of(new USTreasuriesLoadErrorAction(error.message))
          )
        )
    )
  );

  constructor(
    private store: Store<MarketDrawerRootReducerState>,
    private actions: Actions,
    public treasuriesService: TreasuriesService
  ) {}
}
